import React from 'react';
import { IProps } from './types';
import SliderService from 'components/SliderService';
import _ from 'lodash';
import { Link } from 'bff/models/link';
import commonService from 'utils/commonService';

const Service: React.FC<IProps> = (props) => {
  /**
   * @description 建立常見服務 (電腦版)
  */
  const handleCreateServiceLink = () => {
    if (!props.serviceLinks || props.serviceLinks.length === 0) return;

    const child = _.map(props.serviceLinks, (link:Link, index:number) => {
      return (
        <SliderService.Item key={index}>
          <div className="service__item" onClick={() => commonService.validRedirect(link)}>
            <span>{link.NAME}</span>
          </div>
        </SliderService.Item>
      );
    });

    return (
      <SliderService name="service__slider">
        {child}
      </SliderService>
    );
  };

  /**
   * @description 建立常見服務 (手機版)
  */
  const handleCreateServiceLinkMobile = () => {
    if (!props.serviceLinks || props.serviceLinks.length === 0) return;

    const mobileLinkChunk = _.chunk([...props.serviceLinks], 3);

    const child = _.map(mobileLinkChunk, (mobileLink:Link[], index:number) => {
      return (
        <SliderService.Item key={index}>
          {
            _.map(mobileLink, (linkVal:Link, linkValIndex:number) => {
              return (
                <div key={linkValIndex} className="service__item" onClick={() => commonService.validRedirect(linkVal)}>
                  <span>{linkVal.NAME}</span>
                </div>
              );
            })
          }
        </SliderService.Item>
      );
    });

    return (
      <SliderService name="service-mobile__slider">
        {child}
      </SliderService>
    );
  };

  return (
    <div className="service" id={props.isPet ? 'pet-service' : undefined}>
      <div className="template-section">
        <div className="template-container">
          <div className="template-content">
            <div className="service__title-section">
              <div className="service__title">常用服務</div>
            </div>
            <div className="service__slider-section">
              <div className="service__slider-container">
                {handleCreateServiceLink()}
              </div>
            </div>
            <div className="service-mobile__slider-section">
              <div className="service-mobile__slider-container">
                {handleCreateServiceLinkMobile()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
